import i18next from 'i18next';

i18next.addResources('es', 'reference', {
  final: 'Inversión final',
  original: 'Inversión original'
});
